import { MeasureInfo } from "../../../../src/components/election/measure";
import { nov22_contests } from "../../../../src/data/data-nov-2022.js";
import * as React from 'react';
export default {
  MeasureInfo,
  nov22_contests,
  React
};